function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import withStyles from 'isomorphic-style-loader/withStyles';
import App from 'modules/App';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import OrganizationMembershipsAbstract from '../OrganizationMembershipsAbstract';
import styles from '../OrganizationAdmin.pcss';
import ApproveMembershipModal from './ApproveMembershipModal';
import RejectMembershipModal from './RejectMembershipModal';
class PendingOrganizationMemberships extends OrganizationMembershipsAbstract {
    onApproveMembership(organizationMembership) {
        this.onOpenModal(constants.APPROVE_MEMBERSHIP_MODAL, organizationMembership);
    }
    onRejectMembership(organizationMembership) {
        this.onOpenModal(constants.REJECT_MEMBERSHIP_MODAL, organizationMembership);
    }
    get menuActions() {
        return [
            {
                key: 'approveMembership',
                onClick: (organizationMembership)=>this.onApproveMembership(organizationMembership)
            },
            {
                key: 'rejectMembership',
                onClick: (organizationMembership)=>this.onRejectMembership(organizationMembership)
            }
        ];
    }
    renderEmpty() {
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.empty,
            children: [
                /*#__PURE__*/ _jsx("p", {
                    className: "text--bold mb-4",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.pendingOrganizationMembershipsEmptyLead))
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text--small",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.pendingOrganizationMembershipsEmptyText))
                })
            ]
        });
    }
    renderModals() {
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(ApproveMembershipModal, {
                    openModalId: this.props.openModalId,
                    adminOrganizationMembership: this.props.adminOrganizationMembership,
                    organizationMembership: this.activeOrganizationMembership,
                    onClose: ()=>this.onCloseModal()
                }),
                /*#__PURE__*/ _jsx(RejectMembershipModal, {
                    openModalId: this.props.openModalId,
                    adminOrganizationMembership: this.props.adminOrganizationMembership,
                    organizationMembership: this.activeOrganizationMembership,
                    onClose: ()=>this.onCloseModal()
                })
            ]
        });
    }
    renderHeaderMessage() {
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.pendingOrganizationMemberships));
    }
    constructor(props){
        super(props);
        this.status = 'Pending';
    }
}
const mapStateToProps = (state)=>({
        organizationMemberships: selectors.organizationMemberships(state),
        isInProgress: selectors.isFetchOrganizationMembershipsInProgress(state),
        openModalId: App.selectors.modal(state)
    });
const mapDispatchToProps = (dispatch)=>({
        onOpenModal: (modalId)=>dispatch(App.actions.openModal(modalId)),
        onCloseModal: ()=>dispatch(App.actions.closeModal())
    });
const ConnectedPendingOrganizationMemberships = connect(mapStateToProps, mapDispatchToProps)(PendingOrganizationMemberships);
export default withStyles(styles)(ConnectedPendingOrganizationMemberships);
